import { scheduleModalsStyle } from './styles';
import { CreateChancel } from 'components';
import React, { useEffect, useState } from 'react';
import { FindLoad, formatAMPM, useModal } from 'utils';
import moment from 'moment/moment';
import { appointmentService } from '../../../../store/appointment/appointment.service';

export const ConfMultiple = ({ handleSubmit, loadType, recurInfo, occurrence, checkParams }) => {
    const classes = scheduleModalsStyle();
    const loader = FindLoad(loadType);
    const { close } = useModal();
    const [overlappList, setOverlappList] = useState([]);
    const [loadList, setLoadList] = useState(true);

    useEffect(() => {
        appointmentService
            .checkApptOverlapping(checkParams, recurInfo)
            .then((res) => {
                setOverlappList(res?.data);
                setLoadList(false);
            })
            .catch(() => {
                setOverlappList([]);
                setLoadList(false);
            });
    }, []);

    const renderMode = () => {
        if (recurInfo?.mode === 'DAILY') {
            return 'Daily';
        } else if (recurInfo?.mode === 'WEEKLY') {
            return 'Weekly';
        } else if (recurInfo?.mode === 'MONTHLY') {
            return 'Monthly';
        }
    };

    return (
        <div className={classes.lockUnlockWrapper}>
            <p className={classes.confirmTitle}>Confirmation</p>
            <p className={classes.confirmSubTitle}>
                {`You are about to create ${occurrence} appointments with the following recurring pattern. Confirm to proceed.`}
            </p>

            <div className={classes.confirmModalInfoBox}>
                <p>{`Recurrence Mode: ${renderMode()}`}</p>
                <p>{`Occurrence: ${occurrence ? occurrence : 0}`}</p>
                <p>{`Date Range: ${moment.utc(recurInfo?.startDate).format('MM/DD/YYYY')} to ${moment.utc(recurInfo?.endDate).format('MM/DD/YYYY')} `}</p>
            </div>
            {!!overlappList?.length && (
                <div className={classes.confirmModalWornBox}>
                    <p style={{ lineHeight: '22px' }}>{`Cannot create the following appointments due to overlapping schedules.`}</p>
                    <div style={{ maxHeight: '150px', overflow: 'auto' }}>
                        {overlappList?.map((i, j) => (
                            <div key={j}>
                                {i?.staffName && <p style={{ fontWeight: 600 }}>{i?.staffName}</p>}
                                <p
                                    key={j}
                                >{`${i?.displayID} - ${moment.utc(i?.date).format('MM/DD/YYYY')} (${formatAMPM(i?.startTime)} - ${formatAMPM(i?.endTime)})`}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            <CreateChancel
                disabled={loadList}
                loader={!!loader?.length || loadList}
                create={'Confirm'}
                chancel={'Cancel'}
                onCreate={handleSubmit}
                onClose={() => close()}
                buttonWidth="223px"
                createButnMargin={'16px'}
            />
        </div>
    );
};
